import { AttendanceServiceEnum } from "../enums/attendance-cau.enum";
import { AttendanceContractTypeEnum } from "../enums/attendance-contract-type.enum";

export class AttendanceStatusItem {
    index: number;
    day: number;
    attendanceService: AttendanceServiceEnum;
    isHoliday: boolean;
    attendanceContractTypeEnum: AttendanceContractTypeEnum;
  
    constructor(day: number, attendanceService: AttendanceServiceEnum, index: number, isHoliday: boolean, attendanceContractTypeEnum: AttendanceContractTypeEnum) {
      this.day = day;
      this.attendanceService = attendanceService;
      this.index = index;
      this.isHoliday = isHoliday;
      this.attendanceContractTypeEnum = attendanceContractTypeEnum;
    }
  }